angular.module('app.controllers').controller('AreasListCtrl', function ($translate, areasList) {
    const vm = this;

    // własna metoda do filtrowania listy
    vm.listFilter = (area) => {
        if (!area || !vm.search) {
            return true;
        }

        const parts = vm.search.split('+');
        const regExp = new RegExp(parts.join('|'), 'i');
        const subject = [area.name, area.symbol, area.description].join(' ');

        return regExp.test(subject);
    };

    vm.areas = areasList;
});
